"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var getAccessClick_1 = require("./getAccessClick");
var launchFreeCourse_1 = require("./launchFreeCourse");
var chapterClick_1 = require("./chapterClick");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.ButtonInteractionEventNames.GetAccessClick] = getAccessClick_1.getAccessClick,
    _a[analytics_layer_1.ButtonInteractionEventNames.LaunchFreeCourse] = launchFreeCourse_1.launchFreeCourse,
    _a[analytics_layer_1.ButtonInteractionEventNames.ChapterClick] = chapterClick_1.chapterClick,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
